import { Request, req } from '../Repository';
import { setFullToken, checkTokenHeaders } from '../apiHelper';

const resource = '/xdent/clients';

export default {
    getAllClients: token => {
        return req(token).then(token => {
            return Request.get(`${resource}/getallclientsbyuser`, (token));
        })
    },
    getClientById: (id, token) => {
        return req(token).then(token => {
            return Request.get(`${resource}/${id}`, token);
        })
    }
}
